module.exports = __webpack_public_path__ + "img/922.d9178e71.png";